import { memo } from 'react';
import { NodeProps } from 'reactflow';
import { BaseNode } from './BaseNode';
import { CAPI_EVENT_LABELS } from './MetaConversionConfig';

/** Bloco "Conversão Meta Ads": envia o evento pela Conversions API */
export const MetaConversionNode = memo((props: NodeProps) => {
  const c = props.data.config || {};
  const label = CAPI_EVENT_LABELS[c.eventName as string] || 'Lead';
  return <BaseNode {...props} description={c.value ? `${label}: R$ ${c.value}` : label} onDelete={props.data.onDelete} />;
});

MetaConversionNode.displayName = 'MetaConversionNode';
